import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import styled, { css } from "styled-components";

const NewsPageHeader = () => {
    const page = useAppSelector(getCurrentPage);

    if (!page) {
        return null;
    }

    return (
        <Header key={page.id}>
            {page.fields.title && (
                <Typography
                    variant="h1"
                    as="h2"
                    css={css`
                        text-wrap: balance;
                    `}
                >
                    {page.fields.title}
                </Typography>
            )}

            <Author>
                {page.fields.authorImage && <AuthorImage src={page.fields.authorImage} alt={page.fields.author} />}
                <Details>
                    {page.fields.author && <span data-test-selector="newslist_author">{page.fields.author}</span>}
                    {page.fields.publishDate && (
                        <time
                            dateTime={new Date(page.fields.publishDate).toISOString()}
                            data-test-selector="newslist_publishdate"
                        >
                            <LocalizedDateTime
                                dateTime={new Date(page.fields.publishDate)}
                                options={{ year: "numeric", month: "short", day: "numeric" }}
                            />
                        </time>
                    )}
                </Details>
            </Author>
        </Header>
    );
};

const Header = styled.header`
    display: flex;
    flex-direction: column;
    gap: ${rem(10)};
    padding-top: ${rem(20)};
    @media screen and (min-width: ${breakpointWidth("lg")}) {
        gap: ${rem(20)};
        padding-top: ${rem(40)};
    }
`;

const Author = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${rem(10)};
`;

const AuthorImage = styled.img`
    width: ${rem(50)};
    height: ${rem(50)};
    border-radius: 50%;
    border: 3px solid ${colours.lightGreen};
    object-fit: cover;
    @media screen and (min-width: ${breakpointWidth("lg")}) {
        width: ${rem(80)};
        height: ${rem(80)};
    }
`;

const Details = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(5)};
    font-size: ${rem(15)};
    line-height: 1.2em;
    color: ${colours.black};
    @media screen and (min-width: ${breakpointWidth("lg")}) {
        font-size: ${rem(16)};
    }
`;

const widgetModule: WidgetModule = {
    component: NewsPageHeader,
    definition: {
        group: "News Page",
        allowedContexts: ["NewsPage"],
    },
};

export default widgetModule;
